import { Button, Checkbox, Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui"
import { X } from "lucide-react";
import useColumnDrawer from "./useColumnDrawer";

const ColumnDrawer = ({
  open,
  setOpen,
  columns,
  onSave,
}: {
  open: boolean;
  setOpen: any;
  columns: any;
  onSave: any
}) => {
  const {onApply, drawerColumns, onChangeCol} = useColumnDrawer({
    columns,
    onSave
  });

  return (
    <Drawer
      open={open}
      onOpenChange={setOpen}
      direction="right"
    >
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              Select Columns for Line Items
            </DrawerTitle>
            <X
              onClick={() => setOpen(false)}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[110px] px-1">
          <div className="grid grid-cols-1 gap-[18px]">
            {drawerColumns?.map((col: any) => (
              <div
                key={col.key}
                className="flex items-center gap-3 text-[12px]"
              >
                <Checkbox
                  checked={col.checked}
                  onCheckedChange={(checked) =>
                    onChangeCol(col.key, !!checked)
                  }
                />
                <span>{col.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-3 left-0 w-full bg-white px-6 pb-[25px] z-[3]">
          <Button
            type="button"
            onClick={onApply}
            className="w-full bg-primary text-white"
          >
            Apply
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export default ColumnDrawer